<template>
    <div class="steps-page">
        <section class="checkout-nav-section">
            <div class="checkoutnav_wrap">
                <div class="checkoutnav_div">
                    <a href="#" class="link-block-73 w-inline-block"><img src="@/assets/images/Main_Logo.png" loading="lazy" sizes="84.03125px" srcset="@/assets/images/Logo-p-500.png 500w, @/assets/images/Logo-p-800.png 800w, @/assets/images/Main_Logo.png 1000w" alt="" class="image-487"></a>
                    <div class="checkoutnav_progressdiv">
                        <div class="progress_step_div"></div>
                        <div class="progress_step_div current"></div>
                        <div class="progress_step_div"></div>
                        <div class="progress_step_div"></div>
                    </div>
                </div>
            </div>
        </section>
      <section class="checkout-section steps-main">
        <div class="checkoutb_wrap">
          <div class="checkoutb_div">
            <div class="almostdone-div">
              <div class="text-block-1151">Almost Done {{user.first_name}}!</div>
              <div class="text-block-1152">Our 100% digital process will ensure you can start your medical weightloss journey in as little as 3 days.</div>
              <div class="timeline-div">
                <div class="timeline_line"></div>
                <div class="linebullet_div"><img src="@/assets/images/icon_circle-icon.svg" loading="lazy" alt="" class="image-510">
                  <div>
                    <div class="text-block-1153"></div>
                    <div class="text-block-1154">Complete Medical Questionnaire</div>
                    <div class="text-block-1155">Fill out a short online form to submit to the doctor.</div>
                  </div>
                </div>
                <div class="linebullet_div"><img src="@/assets/images/icon_circle-icon.svg" loading="lazy" alt="" class="image-510">
                  <div>
                    <div class="text-block-1153"></div>
                    <div class="text-block-1154">Doctor Review &amp; Prescription</div>
                    <div class="text-block-1155">You will meet with your assigned doctor either through video call or online chat dependent upon your state of residence and your medical history. If approved you will receive an instant notification.</div>
                  </div>
                </div>
                <div class="linebullet_div"><img src="@/assets/images/icon_circle-icon.svg" loading="lazy" alt="" class="image-510">
                  <div>
                    <div class="text-block-1153"></div>
                    <div class="text-block-1154">Our Pharmacy Processes Your Order</div>
                    <div class="text-block-1155">Our State Board Approved 503A Pharmacies will process your order within 24-48 hours (Mon-Thursday). All orders processed on Friday will be shipped on Monday the following week.</div>
                  </div>
                </div>
                <div class="linebullet_div"><img src="@/assets/images/icon_circle-icon.svg" loading="lazy" alt="" class="image-510">
                  <div>
                    <div class="text-block-1153"></div>
                    <div class="text-block-1154">FREE Overnight Cold Shipping</div>
                    <div class="text-block-1155">You can track the packages and get updates directly in our portal.</div>
                  </div>
                </div>
              </div>
              <div class="almost_bottomflex_div">
                <div><img src="@/assets/images/stepsimage_teledoc_PM-p-500.png" loading="lazy" sizes="(max-width: 479px) 17vw, 74.5625px" srcset="@/assets/images/stepsimage_teledoc_PM-p-500.png 500w, @/assets/images/stepsimage_teledoc_PM-p-500.png 641w" alt="" class="image-511"></div>
                <p class="paragraph-153">During this time you can access our Medical Weight Loss Biohacking Guide to help you prepare prior to receiving medication.</p>
              </div>
              <div class="almost-button-div">
                <a href="#" class="button-109 w-button" @click="pushToMedForm()">Complete Medical Form <span class="text-span-247">-&gt;</span></a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- TrustPilot footer (sticky to bottom of viewport on short content) -->
      <div class="trust-pilot-div steps-footer">
        <img src="@/assets/images/icon_stars.svg" loading="lazy" alt="" class="image-689">
        <div class="flow-rating-div">
          <div class="text-block-1723">Excellent</div>
          <div class="text-block-1724">4.6 out of 5</div>
          <img src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/683486885685e2905f4c45af_Trustpilot_Logo_(2022).svg.webp" loading="lazy" alt="Trustpilot" class="image-690">
        </div>
        <div>Trusted by thousands of members</div>
      </div>
    </div>
    </template>
    <script>
    
    import { mapGetters } from 'vuex';
    export default {
        name: 'paymentThanks',
        props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
        data() {
            return {
                active_el: 1,
                selectedOption:'',
                submitting: false,
            }
        },
        computed:{
            ...mapGetters(['getRemainingPrescriptions','user']),
            remainingPrescriptions() {
                return this.getRemainingPrescriptions;
            },
            getDrugName(){
                return this.selectedOption === '' ? 'GLP Anti-Nausea and GLP Energy' : this.selectedOption === 'B12' ? 'GLP Anti-Nausea' : 'GLP Energy'
            },
            getProductName(){
                return JSON.parse(localStorage.getItem("planName"))
            }
        },
        watch: {
            active_el() {
                window.scrollTo(0, 0)
            }
        },
        methods:{
         
            setMedSelected(value){
                this.selectedOption = value;
                this.moveToNext();
            },
            moveToNext(){
                this.active_el=2;
            },
            async sendRequest(product){
              let response = await this.$axios.post(`${this.baseUrl}/api/bundle-selected`, {
                  selectedMed: product
              });
              return response;
            },
            async addBundleAndMove(){
                this.submitting = true;
                if(this.selectedOption!=''){
                    let response = await this.sendRequest(this.selectedOption);
                    console.log(response)
                    this.active_el=3;
                }else{
                  let response = await this.sendRequest("None");
                  console.log(response)
                  this.active_el=3;
                }
                
            },
            pushToMedForm(){
              this.$router.push({
                        name: 'verifyPhoneAndEmail'
              });
            }
        },
        mounted(){
            console.log(this.remainingPrescriptions)
            
        }
    }
    </script>
    <style scoped>
    /* Sticky-footer: #app is already `display: flex; flex-direction: column; min-height: 100vh`.
       Giving .steps-page `flex: 1` makes it fill remaining viewport space, which pushes the
       global teal site footer (rendered after router-view in App.vue) down to the bottom of
       the viewport. When content grows tall, this naturally lets the browser scroll. */
    .steps-page {
        flex: 1;
        background-color: var(--f6-grey, #f6f6f6);
    }
    .checkout-nav-section {
        background-color: #fff;
    }
    .steps-main {
        background-color: var(--f6-grey, #f6f6f6);
    }
    .steps-footer {
        background-color: var(--f6-grey, #f6f6f6);
        padding: 8px 16px 24px;
    }
    .trust-pilot-div {
        display: flex;
        flex-flow: column;
        justify-content: flex-start;
        align-items: center;
        margin-top: 10px;
    }
    .image-689 {
        height: 15px;
        width: auto;
        margin-bottom: 10px;
    }
    .flow-rating-div {
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        gap: 10px;
        margin-bottom: 8px;
    }
    .text-block-1723 {
        font-weight: 900;
        font-size: 14px;
        line-height: 16px;
    }
    .text-block-1724 {
        font-size: 12px;
        line-height: 12px;
    }
    .image-690 {
        height: 18px;
        width: auto;
    }

    .selected-plan-img{
        width: 45px;
    }
    </style>